export default function () {
  const route = useRoute()

  const {
    meta,
    site_name,
    site_description,
    site_image,
    ngo,
    locale,
    index,
  } = getData().data

  const { base_url, index_site } = useRuntimeConfig().public

  const url = () => base_url + route.path

  const title = () => `${site_name}` //  - ${siteSlogan}

  const is_frontpage = route.path === '/'

  const primaryColor = usePrimaryColor()

  const addToHead = {
    htmlAttrs: {
      lang: locale,
    },
    link: [
      {
        rel: 'icon',
        type: 'image/x-icon',
        href: '/favicon.ico',
        sizes: 'any',
      },
      {
        rel: 'icon',
        type: 'svg+xml',
        href: '/logo.svg',
        sizes: 'any',
      },
      {
        rel: 'apple-touch-icon',
        type: 'image/png',
        href: '/apple-touch-icon-180x180.png',
      },
    ],
  }

  if (is_frontpage && base_url) {
    addToHead.link.push({
      rel: 'canonical',
      type: 'canonical',
      href: base_url,
    })
  }

  useHead(addToHead)

  useSeoMeta({
    robots:
      is_frontpage && index && index_site === true
        ? 'index, noarchive, nosnippet'
        : 'noindex, nofollow, nosnippet',
    title: title,
    ogTitle: title,
    themeColor: primaryColor,
    description: site_description,
    ogDescription: site_description,
    ogImage: () => base_url + site_image.path,
    ogImageWidth: site_image.width,
    ogImageHeight: site_image.height,
    ogImageAlt: site_image.alt,
    ogImageType: site_image.mime as 'image/jpeg' | 'image/png' | 'image/gif' | undefined, // this is correct, but is a string
    twitterTitle: title,
    twitterDescription: site_description,
    twitterCard: 'summary_large_image',
    twitterImage: site_image.path,
    ogType: 'website',
    ogUrl: url,
    ogSiteName: site_name,
    ogLocale: locale,
    author: ngo.name,
    // Facebook
    fbAppId: meta.app_id,
  })
}
